import React from "react";
import { User } from "../types/User";

export interface StateType {
  authenticated: boolean;
  user: User | null;
  token: string | null;
  darkMode: boolean;
}

export const DefaultState = {
  authenticated: false,
  user: null,
  token: null,
  darkMode: true,
} as StateType;

export interface RootContextType {
  state: StateType;
  login(user: User, token: string): void;
  logout(): void;
  init(user: User | null, token: string | null, darkMode: boolean | null): void;
  toggleDarkMode(): void;
}

export const RootContext = React.createContext<RootContextType | null>(null);